import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
    width: "18",
    height: "18",
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2 = ["stroke-width"];
export default /*@__PURE__*/ _defineComponent({
    __name: 'gift-icon',
    props: {
        strokeWidth: {
            type: Number,
            default: 1.5,
        },
    },
    setup(__props) {
        const props = __props;
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
                _createElementVNode("path", {
                    d: "M15.4002 9.00037V15.0004C15.4002 16.1049 14.5048 17.0004 13.4002 17.0004H4.60025C3.49568 17.0004 2.60024 16.1049 2.60024 15.0004V9.00037M9.00024 17.0004V5.00037M9.00024 5.00037H5.40024C4.86981 5.00037 4.3611 4.78965 3.98603 4.41458C3.61096 4.03951 3.40024 3.5308 3.40024 3.00037C3.40024 2.46993 3.61096 1.96123 3.98603 1.58615C4.3611 1.21108 4.86981 1.00037 5.40024 1.00037C8.20024 1.00037 9.00024 5.00037 9.00024 5.00037ZM9.00024 5.00037H12.6002C13.1307 5.00037 13.6394 4.78965 14.0145 4.41458C14.3895 4.03951 14.6002 3.5308 14.6002 3.00037C14.6002 2.46993 14.3895 1.96123 14.0145 1.58615C13.6394 1.21108 13.1307 1.00037 12.6002 1.00037C9.80024 1.00037 9.00024 5.00037 9.00024 5.00037ZM3.00024 9.00037H15.0002C16.1048 9.00037 17.0002 8.10494 17.0002 7.00037V7.00037C17.0002 5.8958 16.1048 5.00037 15.0002 5.00037H3.00024C1.89567 5.00037 1.00024 5.8958 1.00024 7.00037V7.00037C1.00024 8.10494 1.89567 9.00037 3.00024 9.00037Z",
                    stroke: "currentColor",
                    "stroke-width": props.strokeWidth,
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round"
                }, null, 8, _hoisted_2)
            ]));
        };
    }
});
